<template>
  <b-card title="MR Directory">
    <mr-filter @filtersUpdated="filtersChangeHandler" />
    <mr-list :filters="filters" />
  </b-card>
</template>

<script>
import {
  BCard,
} from 'bootstrap-vue'
import MrList from '@/components/Sales/MrList/MrTable.vue'
import MrFilter from '@/components/Sales/MrList/MrFilter.vue'

export default {
  components: {
    BCard,
    MrList,
    MrFilter,
  },
  data() {
    return {
      filters: {},
    }
  },
  methods: {
    filtersChangeHandler(filterData) {
      this.filters = filterData
    },
  },
}

</script>
